<div class="modal-form">
  <div class="form-modal">
    <div class="close-button" (click)="closeAgregar()">
      x
    </div>
    <div *ngIf="showFileBody">
      <h4 style="color:#5754a3;margin-bottom: 30px">SUBIR ARCHIVO MULTIMEDIA DEL MÓDULO </h4>
      <div class="hero is-fullheight">
        <div class="hero-body">
          <div class="container">
            <div class="columns is-multiline">
              <div class="column is-8 is-offset-2">
                <div class="drop-container" ngFileDrop [options]="options" (uploadOutput)="onUploadOutput($event)"
                     [uploadInput]="uploadInput">
                  <p>
                    Arraste el archivo aqui o
                    <label class="upload-button">
                      <input type="file" ngFileSelect [options]="options" (uploadOutput)="onUploadOutput($event)"
                             [uploadInput]="uploadInput">
                      seleccionar
                    </label>
                  </p>
                </div>
              </div>
              <div class="column is-8 is-offset-2">
                <div class="upload-items">
                  <div class="upload-item" *ngFor="let f of files; let i = index;">
              <span class="filename">
                <span>{{ f.progress?.data?.percentage }}%</span>
                <span>subiendo a {{ f.progress?.data?.speedHuman }}</span>
              </span>
                    <div class="progress">
                      <span class="bar" [style.width]="f?.progress?.data?.percentage + '%'"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="showTimeBody">
      <h4 style="color:#5754a3;margin-bottom: 30px">AGREGAR DURACION DEL FRAME</h4>
      <div class="form-group">
        <label for="exampleSegundos" style="text-align: left">Duración de la imagen</label>
        <input type="number" class="form-control" id="exampleSegundos"
               placeholder="Ingrese la duración" [(ngModel)]="segundos">
        <small id="emailHelp" class="form-text text-muted">Debe ser mayor de 0.</small>
      </div>
      <div class="form-group" style="text-align: center">
        <button type="button" (click)="crearFrameImagen()"
                [disabled]="segundos<=0" [ngClass]="{'btn-danger':segundos>0}"
                style="margin-top: 10px;  margin:10px"
                class="btn btn-lg">Completar creación
        </button>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/admin/upload-view/upload-view.component.html